import { AccessCondition, AccessString } from 'providers/auth.service';

export const navigationButtons: {
    /** Can be translate key */
    name: string;
    svgIcon: string;
    routerLink: string;
    /** ceDevelopment directive is applied if this is set to true */
    development?: boolean;
    /** For system admins only */
    sysAdminOnly?: boolean;
    /** Require this permission to see this page */
    access?: AccessString;
    /** Condition for checking permission - either OR or AND */
    accessCondition?: AccessCondition;
    /** Allow only these static tenant ids to see this. Tenant not including here cannot see */
    tenantIds?: string[];
    section?: 'admin';
}[] = [
    {
        name: $localize`:Main header for the page:Locations`,
        svgIcon: 'ev-station',
        routerLink: '/search',
    },
    {
        name: $localize`:Main header for the page:Vehicles`,
        svgIcon: 'bus-multiple',
        routerLink: '/vehicles',
        access: 'ev.allowTracking',
    },
    {
        name: $localize`:Main header for the page:Reporting`,
        svgIcon: 'chart-box-outline',
        routerLink: '/reporting',
        access: 'fleet.chargingStation.usage.access',
    },
    {
        name: $localize`:Main header for the page:Fleet`,
        svgIcon: 'map-legend',
        routerLink: '/fleet',
        access: ['fleet.tenantLevelPowerCurve'],
        accessCondition: 'OR',
    },
    {
        name: $localize`:Main header for the page:Settings`,
        routerLink: '/settings',
        svgIcon: 'cog',
        access: 'sysadmin',
    },
    {
        name: $localize`:Main header for the page:Power groups`,
        svgIcon: 'c-flash',
        routerLink: '/power-groups',
        access: 'loadBalancing.access',
    },
    {
        name: $localize`:Main header for the page:System Health Dashboard`,
        routerLink: '/health',
        svgIcon: 'c-cloud-monitor',
        sysAdminOnly: true,
    },
    {
        name: $localize`:Main header for the page:Audit logs`,
        routerLink: '/audit-logs',
        svgIcon: 'c-report',
        sysAdminOnly: true,
        development: true,
    },
    {
        name: $localize`:Main header for the page:Organizations & Users`,
        routerLink: '/admin/iam',
        svgIcon: 'account-group',
        section: 'admin',
        access: 'sysadmin',
        accessCondition: 'OR',
    },
    {
        name: $localize`:Main header for the page:Services`,
        routerLink: '/admin/svc',
        svgIcon: 'm-puzzle',
        section: 'admin',
        access: 'sysadmin',
        accessCondition: 'OR',
    },

    /** in case user is both sysadmin and orgadmin, the button below will be deemed duplicates, and be removed from UI */
    {
        name: $localize`:Main header for the page:User management`,
        routerLink: '/admin/iam',
        svgIcon: 'account-group',
        section: 'admin',
        access: 'orgAdmin',
        accessCondition: 'OR',
    },
    {
        name: $localize`:Main header for the page:EV Identifications`,
        routerLink: '/admin/ev-identify-verifier',
        svgIcon: 'car-key',
        section: 'admin',
        access: 'sysadmin',
        accessCondition: 'OR',
    },
];
